export const PROJECTS = [
    // Order 1 - Vital Concept
    {
        orderNumber: 1,
        _id: '1',
        url: 'vital-concept',
        name: {
            bg: '',
            en: ''
        },
        client_id: 4,
        description: {
            bg: 'Серия уеб банери за хранителни добавки.',
            en: ''
        },
        year: '2016',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Vital_Concept',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            // 'Relax_banner_300x250px.png',
            // 'Relax_banner_300x600px.png',
            // 'Relax_banner_320x100px.png',
            'Relax_banner_2000x1000px.jpg',

            // 'Food_banner_300x250px.jpg',
            // 'Food_banner_300x600px.gif',
            'Food_banner_2000x1000px.jpg',

            // 'Winter_Combo_facebook_300x250px.jpg',
            'Winter_Combo_facebook_1200x628px.jpg',
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 2 - Enoteca
    {
        orderNumber: 2,
        _id: '2',
        url: 'enoteca',
        name: {
            bg: '',
            en: ''
        },
        client_id: 7,
        description: {
            bg: 'Разработка на запазен знак и уеб страница.',
            en: 'Logo and web page design.'
        },
        year: '2015',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Enoteca',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Enoteca_logo.jpg',
            'Enoteca_WebPage.jpg'
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 3 - Omnia Sourcing
    {
        orderNumber: 3,
        _id: '3',
        url: 'omnia-sourcing',
        name: {
            bg: '',
            en: ''
        },
        client_id: 8,
        description: {
            bg: 'Лого. Дизайн на уеб страница',
            en: 'Logo. Web page design.'
        },
        year: '2014',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Omnia_Sourcing',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Omnia_Sourcing_logo.jpg',
            'Omnia_Sourcing_Home_Page.jpg',
            'Omnia_Sourcing_Home_Page_menu.jpg',
            'Omnia_Sourcing_Services_Page.jpg'
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 4 - BAT_2016
    {
        orderNumber: 4,
        _id: '4',
        url: 'bat-2016',
        name: {
            bg: '',
            en: ''
        },
        client_id: 5,

        description: {
            bg: 'Лого. Визизя събития 2016. Уеб страниица.',
            en: 'Logo. Events 2016 vision. Web page design.'
        },
        year: '2016',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'BAT_2016',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'BAT_vision_2016_01.jpg',
            'BAT_vision_2016_02.jpg',
            'BAT_vision_2016_03.jpg',
            'BAT_web_page.png'
        ],

        galleryColumns: '2',

        videos: [],
    },

    // Order 5 - Globus Cement
    {
        orderNumber: 5,
        _id: '5',
        url: 'globus-cement',
        name: {
            bg: '',
            en: ''
        },

        client_id: 9,

        description: {
            bg: 'Рекламна визия на цимент GLOBUS',
            en: 'GLOBUS cement vision'
        },
        year: '2015',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Globus_Cement',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'GLOBUS_cement.jpg',
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 6 - Equilibrium
    {
        orderNumber: 6,
        _id: '6',
        url: 'equilibrium',
        name: {
            bg: '',
            en: ''
        },
        client_id: 3,

        description: {
            bg: 'Опаковки',
            en: 'Packs'
        },
        year: '2014',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Equilibrium',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Equilibrium_pack_01.jpg',
            'Equilibrium_pack_02.jpg',
            'Equilibrium_pack_03.jpg',
            'Equilibrium_pack_04.jpg',
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 7 - The Legacy
    {
        orderNumber: 7,
        _id: '7',
        url: 'the-legacy',
        name: {
            bg: 'Завещанието',
            en: 'The Legacy'
        },
        client_id: 1,

        description: {
            bg: 'Календар 2016',
            en: 'Calendar 2016'
        },
        year: '2015',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'The_Legacy',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            // 'The_Legacy_cover_01.jpg',
            // 'The_Legacy_cover_02.jpg',
            'The_Legacy_01.jpg',
            'The_Legacy_02.jpg',
            'The_Legacy_03.jpg',
            'The_Legacy_04.jpg',
            'The_Legacy_05.jpg',
            'The_Legacy_06.jpg',
            'The_Legacy_07.jpg',
            'The_Legacy_08.jpg',
            'The_Legacy_09.jpg',
            'The_Legacy_10.jpg',
            'The_Legacy_11.jpg',
            'The_Legacy_12.jpg',
        ],

        galleryColumns: '2',

        videos: [],
    },

    // Order 8 - Ani & Ivan
    {
        orderNumber: 8,
        _id: '8',
        url: 'ani-i-ivan',
        name: {
            bg: '',
            en: ''
        },
        client_id: 6,
        description: {
            bg: 'Сватбени покани. ',
            en: 'Wedding invitations.'
        },
        year: '2018',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Ani_and_Ivan',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Ani&Ivan_01.jpg',
            'Ani&Ivan_02.jpg',
            'Ani&Ivan_03.jpg',
            'Ani&Ivan_04.jpg',
        ],

        galleryColumns: '2',

        videos: [],
    },

    // Order 9 - Eco
    {
        orderNumber: 9,
        _id: '9',
        url: 'toplivo-eco-calendar-2010',
        name: {
            bg: '',
            en: ''
        },
        client_id: 1,
        description: {
            bg: 'Календар 2010',
            en: 'Calendar 2010'
        },
        year: '2009',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Eco_Calendar',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Eco_August.jpg',
            'Eco_February.jpg',
            'Eco_September.jpg',
            'Eco_June_01.jpg'
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 10 - BAT 2015
    {
        orderNumber: 10,
        _id: '10',
        url: 'bat-2015',
        name: {
            bg: '',
            en: ''
        },
        client_id: 5,
        description: {
            bg: 'Визизя събития 2015',
            en: 'Vision for events 2015'
        },
        year: '2015',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'BAT_2015',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Lulin_Cup_2015.jpg',
            'Pernik_Cup_2015.jpg',
            'Vratza_Cup_2015.jpg'
        ],

        galleryColumns: '2',

        videos: [],
    },

    // Order 11 - TOKO
    {
        orderNumber: 11,
        _id: '11',
        url: 'toko-coffee',
        name: {
            bg: '',
            en: ''
        },
        client_id: 2,
        description: {
            bg: 'Запазен знак. Опаковки.',
            en: 'Logo. Pack design.'
        },
        year: '2013',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'TOKO',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Toko_250g_all.jpg',
            'Toko_250g.jpg',
            'Toko_cup.jpg',
            // 'TOKO_Logo.jpg',
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 12 - Graffiti
    {
        orderNumber: 12,
        _id: '12',
        url: 'toplivo-graffiti',
        name: {
            bg: '',
            en: ''
        },
        client_id: 1,

        description: {
            bg: 'Графити',
            en: 'Graffiti'
        },
        year: '2016',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Graffiti',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Toplivo_Graffiti_all.jpg',
            'Toplivo_Graffiti_01.jpg',
            'Toplivo_Graffiti_02.jpg',
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 13 - Maxxmart
    {
        orderNumber: 13,
        _id: '13',
        url: 'maxxmart',
        name: {
            bg: '',
            en: ''
        },
        client_id: 11,

        description: {
            bg: 'Запазен знак',
            en: 'Logo'
        },
        year: '2017',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Maxxmart',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            // 'Maxxmart_logo.jpg',
            'Maxxmart_01.jpg',
            'Maxxmart_02.jpg',
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 14 - Orlen Oils
    {
        orderNumber: 14,
        _id: '14',
        url: 'orlen-oils',
        name: {
            bg: '',
            en: ''
        },
        client_id: 10,

        description: {
            bg: 'Колаж',
            en: 'Collage'
        },
        year: '2014',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Orlen_Oils',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [],

        galleryColumns: '1',

        videos: [
            {
                url: 'orlen.mp4',
                poster: 'orlen.jpg'
            }],
    },

    // Order 15 - Born with Luck
    {
        orderNumber: 15,
        _id: '15',
        url: 'born-with-luck',
        name: {
            bg: 'Роден с късмет',
            en: 'Born with Luck'
        },
        client_id: 1,

        description: {
            bg: 'Календар 2018',
            en: 'Calendar 2018'
        },
        year: '2017',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Born_With_Luck',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Born_With_Luck_cover.jpg',
            'Born_With_Luck_prolog.jpg',
            'Born_With_Luck_01.jpg',
            'Born_With_Luck_02.jpg',
            'Born_With_Luck_03.jpg',
            'Born_With_Luck_04.jpg',
            'Born_With_Luck_05.jpg',
            'Born_With_Luck_06.jpg',
            'Born_With_Luck_07.jpg',
            'Born_With_Luck_08.jpg',
            'Born_With_Luck_09.jpg',
            'Born_With_Luck_10.jpg',
            'Born_With_Luck_11.jpg',
            'Born_With_Luck_12.jpg',
        ],

        galleryColumns: '2',

        videos: [],
    },

    // Order 16 - Walltopia
    {
        orderNumber: 16,
        _id: '16',
        url: 'walltopia-mailing',
        name: {
            bg: '',
            en: ''
        },
        client_id: 12,

        description: {
            bg: 'Мейлинг темплейт',
            en: 'Mailing Template'
        },
        year: '2016',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Walltopia',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'Walltopia_mailing.jpg',
        ],

        galleryColumns: '1',

        videos: [],
    },

    // Order 17 - Music in Colors
    {
        orderNumber: 17,
        _id: '17',
        url: 'music-in-colors',
        name: {
            bg: '',
            en: ''
        },
        client_id: 9,

        description: {
            bg: 'Цветови картел',
            en: 'Color Sample'
        },
        year: '2016',
        webPage: '',

        isStar: true,
        isBlocked: false,

        categoryIds: [],

        projectFolder: 'Music_in_Colors',

        thumbnail: 'thumbnail.jpg',
        mobileThumbnail: 'thumbnail_mobile.jpg',
        cover: 'cover.jpg',

        images: [
            'music_in_colors_01.jpg',
            // 'music_in_colors_03.jpg',
            // 'music_in_colors_04.jpg',
            'music_in_colors_05.jpg',
            'music_in_colors_06.jpg',
            'music_in_colors_09.jpg',
        ],

        galleryColumns: '1',

        videos: [],
    },
];